module.exports = __webpack_public_path__ + "img/resized-APP-0014-2.7f0a91d4.png";